const React = require('react');

const {AdminTrxRouting} = require('../../../../../dumb/AdminHelpers/AdminTrx/');

const Table = require('./components/Table');
const Details = require('./components/Details');

module.exports = () => (
  <AdminTrxRouting
    views={{
      table: Table,
      details: Details
    }}
  />
);
